// ======================================================================
// File: IndentTimeline.jsx
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Display indent lifecycle history
// - Read-only audit trail
//
// ======================================================================

import React from "react";

export default function IndentTimeline({ history = [] }) {
  if (!history || history.length === 0) {
    return (
      <div className="erp-timeline-empty">
        No activity history available
      </div>
    );
  }

  return (
    <div className="erp-timeline">
      <h4>Indent History</h4>

      <ul>
        {history.map((item, index) => (
          <li key={index}>
            <div className="timeline-dot" />

            <div className="timeline-content">
              <strong>{item.action}</strong>

              <div>
                By: {item.performed_by || "System"}
              </div>

              <div className="timeline-date">
                {item.performed_at}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
